// Runtime settings the server writes into /config.js, so one image serves every environment.
declare global {
  interface Window {
    __KORA_AUTH__?: { kratosPublicUrl?: string };
  }
}

export const config = {
  kratosPublicUrl: (window.__KORA_AUTH__?.kratosPublicUrl || "http://localhost:4433").replace(/\/$/, ""),
};
